import { useState } from "react";
import { useDispatch } from "react-redux";
import ModalGeneric from "../../Common/ModalGeneric";

import InternkoderForm from "../InternkoderForm";
import OpenModalComponent from "./OpenModalComponent";

import { postInternkoderIleggelser } from "../../../actions/internkoderIleggelserActions";
import { postInternkoderMiljogebyr } from "../../../actions/internkoderMiljogebyrActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../utils/validationUtils";

const rules = {
  id: "required;isDigit;minValue=1",
  beskrivelse: "required;minLength=3;maxLength=50",
  aktivertDato: "isDato;isLessThan=deaktivertDato",
  deaktivertDato: "isDato;isLargerThan=aktivertDato",
};

const initState = {
  open: false,
  submitButtonText: "Legg til ny",
  id: "",
  beskrivelse: "",
  aktivertDato: "",
  deaktivertDato: "",
  aktiv: true,
  validationError: {},
  openDeaktiverConfirm: false,
};

export default function InternkoderModal({ modalToRender }) {
  const dispatch = useDispatch();
  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  const closeModal = () => setState(initState);
  const openModal = () => update({ open: true });

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePost = async () => {
    update({ submitButtonText: "Legger til..." });

    const payload = {
      id: state.id && Number(state.id),
      aktivertDato: state.aktivertDato || null,
      deaktivertDato: state.deaktivertDato || null,
      beskrivelse: state.beskrivelse,
    };

    const action =
      modalToRender === "ileggelser"
        ? dispatch(postInternkoderIleggelser(payload))
        : dispatch(postInternkoderMiljogebyr(payload));

    action
      .then(() => closeModal())
      .catch(() => update({ submitButtonText: "Legg til ny" }));
  };

  const saveAndClose = (e) => {
    if (e) e.preventDefault();
    if (isValid() && !state.deaktivertDato) {
      handlePost();
    } else if (isValid() && state.deaktivertDato) {
      update({ open: false, openDeaktiverConfirm: true });
    }
  };

  const handleChange = (e) => {
    const draft = { ...state, [e.target.name]: e.target.value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  const modalTitle =
    modalToRender === "ileggelser"
      ? "Legg til ny internkode for ileggelser"
      : "Legg til ny internkode for miljøgebyr";

  return (
    <>
      <ModalGeneric
        modalTitle={modalTitle}
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={OpenModalComponent}
        submit={saveAndClose}
        submitButtonText={state.submitButtonText}
      >
        <InternkoderForm
          id={state.id}
          beskrivelse={state.beskrivelse}
          aktivertDato={state.aktivertDato}
          deaktivertDato={state.deaktivertDato}
          validationError={state.validationError}
          handleChange={handleChange}
        />
      </ModalGeneric>
      <ModalGeneric
        modalTitle="Deaktiver internkode"
        open={state.openDeaktiverConfirm}
        closeModal={() => update({ openDeaktiverConfirm: false, open: true })}
        submit={() => handlePost()}
        submitButtonText={state.submitButtonText}
      >
        <p>Vil du deaktivere internkode {state.id}?</p>
      </ModalGeneric>
    </>
  );
}
